export const getGasesEfeitoEstufa = (state) => state.gasesEfeitoEstufa.lista
export const getTotalGasesEfeitoEstufa = (state) => state.gasesEfeitoEstufa.total
export const getIsCarregandoListaGasesEfeitoEstufa =
  (state) => state.gasesEfeitoEstufa.isCarregandoLista
export const getGasesEfeitoEstufaSelecionado = (state) => state.gasesEfeitoEstufa.selecionado
export const getIsCarregandoGasesEfeitoEstufa =
  (state) => state.gasesEfeitoEstufa.isCarregandoGasesEfeitoEstufa
export const getIsSavingGasesEfeitoEstufa = (state) => state.gasesEfeitoEstufa.isSaving
